<script>
  import QuestionnaireAppType from "../components/estimator/QuestionnaireAppType.svelte";
  import QuestionnaireLogins from "../components/estimator/QuestionnaireLogins.svelte";
  import QuestionnaireProfiles from "../components/estimator/QuestionnaireLogins.svelte";
  import QuestionnairePurchases from "../components/estimator/QuestionnairePurchases.svelte";
  import QuestionnaireGlamour from "../components/estimator/QuestionnaireGlamour.svelte";
  import QuestionnaireIcons from "../components/estimator/QuestionnaireIcons.svelte";
  import Selectable from "../components/estimator/Selectable.svelte";
  import Contact from "../components/Contact.svelte";
  import { budget } from "../stores.js";

  let selectedPlatforms = [];
  let allowedPlatforms = ["platform-android", "platform-ios", "platform-web"];

  let questionnaireAppTypeActive = true;
  let questionnaireLogins = false;
  let questionnaireProfiles = false;
  let questionnairePurchases = false;
  let questionnaireGlamour = false;
  let questionnaireIcon = false;
  let contact = false;

  function transitionAppType() {
    questionnaireAppTypeActive = !questionnaireAppTypeActive;
    questionnaireLogins = true;
  }

  function transitionLogins() {
    questionnaireLogins = !questionnaireLogins;
    questionnaireProfiles = true;
  }

  function transitionProfiles() {
    questionnaireProfiles = !questionnaireProfiles;
    questionnairePurchases = true;
  }

  function transitionPurchases() {
    questionnairePurchases = !questionnairePurchases;
    questionnaireGlamour = true;
  }

  function transitionGlamour() {
    questionnaireGlamour = !questionnaireGlamour;
    questionnaireIcon = true;
  }

  function transitionIcon() {
    questionnaireIcon = !questionnaireIcon;
    contact = true;
  }
</script>

<style>
  .left {
    float: left;
  }

  .right {
    float: right;
  }
  .page-header {
    height: 20vh !important;
  }
</style>
<div
  class="page-header header-filter blue-filter"
  data-parallax="true"
  style="background-image: url('/assets/img/web.jpg')" />
<div>
  <div class="main main-raised">
    <div class="container">
      <div class="section text-center">
        <div class="row">
          <div class="ml-auto mr-auto">
            <p><b>Code World Solutions Cost Estimator</b></p>
            <p>Budget: ${$budget}</p>
            {#if questionnaireAppTypeActive}
              <h1>Select your App Type</h1>
              <h3>And remember this is just an estimate</h3>
              <h4>(Pick all that apply)</h4>

              <QuestionnaireAppType />

              <input
                type="button"
                value="Next"
                class="right btn btn-info"
                on:click={transitionAppType} />
            {/if}

            {#if questionnaireLogins}
              <h1>Does Your App Idea Have Logins?</h1>
              <QuestionnaireLogins />

              <input
                type="button"
                value="Next"
                class="right btn btn-info"
                on:click={transitionLogins} />
            {/if}

            {#if questionnaireProfiles}
              <h1>Will Your App Idea Have User Profiles?</h1>
              <QuestionnaireProfiles />

              <input
                type="button"
                value="Next"
                class="right btn btn-info"
                on:click={transitionProfiles} />
            {/if}

            {#if questionnairePurchases}
              <h1>Will Your App Idea Have In-App Purchases?</h1>
              <QuestionnairePurchases />

              <input
                type="button"
                value="Next"
                class="right btn btn-info"
                on:click={transitionPurchases} />
            {/if}

            {#if questionnaireGlamour}
              <h1>What Style Are You Looking For?</h1>
              <QuestionnaireGlamour />

              <input
                type="button"
                value="Next"
                class="right btn btn-info"
                on:click={transitionGlamour} />
            {/if}

            {#if questionnaireIcon}
              <h1>
                Do You Need An High Quality App Icon (Increases store rank!)
              </h1>
              <QuestionnaireIcons />

              <input
                type="button"
                value="Next"
                class="right btn btn-info"
                on:click={transitionIcon} />
            {/if}

            {#if contact}
              <Contact />
            {/if}

            <input
              type="button"
              value="Reset"
              class="right btn btn-info btn-danger"
              style="margin-right: 32px"
              on:click={() => window.location.replace('/estimator')} />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
